import {Form} from "./modules/Form";

export default function useForm() {
    for (const bannerFormComponent of document.querySelectorAll('[data-component="banner-form"]')) {
        new Form({
            element: bannerFormComponent,
        });
    }
}
